import { Close } from '@mui/icons-material';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField
} from '@mui/material';
import { Stack } from '@mui/system';

import { useTranslation } from 'react-i18next';

import { CopyToClipboardButton } from 'app/components/CopyToClipboardButton';
import { translations } from 'locales/i18n';

interface Props {
  apiKeyToShow: string | null;
  handleClose: () => void;
}

export const APIKeyShowDialog = ({ apiKeyToShow, handleClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={!!apiKeyToShow}
      onClose={(_, reason) => reason !== 'backdropClick' && handleClose}
      fullWidth
    >
      <DialogTitle>{t(translations.pages.chat.apiKeys.showAPIKeyDialog.title())}</DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={() => ({
          position: 'absolute',
          right: 8,
          top: 8
        })}
      >
        <Close />
      </IconButton>
      <DialogContent>
        <Stack gap={3}>
          <Stack gap={1}>
            <Alert severity="warning" sx={{ fontSize: 14, fontWeight: 'bold' }}>
              {t(translations.pages.chat.apiKeys.showAPIKeyDialog.description())}
            </Alert>
            <TextField
              size="small"
              margin="dense"
              disabled
              value={apiKeyToShow}
              fullWidth
              InputProps={{ endAdornment: <CopyToClipboardButton textToCopy={apiKeyToShow} /> }}
            />
          </Stack>

          <Button
            variant="contained"
            size="small"
            sx={{ alignSelf: 'flex-end' }}
            color="warning"
            onClick={handleClose}
          >
            {t(translations.common.close())}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
